import React, { useState } from 'react'
import './sign-in.styles.scss'
import './google-btn.styles.scss'
import { GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth'
import { auth, signInWithGoogle } from '@/utils/firebase.utils'
import { Link, useNavigate } from 'react-router-dom';
import googleImg from '@/assets/google.png';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component'
import BrandLogo from '@/components/SHARED/brand-logo/brand-logo.component';
import { ModalAlert } from '@/components/modal/modal.component'

const SignIn = () => {

    const [ email, setEmail ] = useState('');
	const [ password, setPassword ] = useState('');
    const [ alertMessage, setAlertMessage ] = useState(null);
    const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();		
		signInWithEmailAndPassword(auth, email, password)
		.then((userCredential) => {
			// Signed in 
			// const user = userCredential.user;
			// ...
            console.log(userCredential)
            navigate('/loading');
		}).catch(err => {
            setAlertMessage('Sorry, the email and/or password doesn\'t match our records.');
        })
		
		setEmail('')
		setPassword('')
	}

    async function startGoogleSignin() {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
        .then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            navigate('/loading')
            // IdP data available using getAdditionalUserInfo(result)
            // ...
        }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            // ...
        });
    }

    return (
        <div>
            <UnauthLayout>
            <div className='sign-in-container'>
                <div className='sign-in-content'>
                    <div className='sign-in-card g-card'>
                        <div className='icon-container'>
                            <BrandLogo theme='hardwood' tone='light' />
                        </div>
                        <div className="g-space-40"></div>
                            
                        <div className='center-box'>
                            <button onClick={() => startGoogleSignin()} className="g-button provider-button" >
                                <img src={googleImg} />
                                Sign in with Google
                            </button>
                            <p><b>- OR -<br />
                            Sign in with your email and password</b></p>
                        </div>
                        <div className="field" >
                            <input type="text" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                            <div className="g-space-20"></div>
                            <input className="uk-input" type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        
                        <div className='buttons'>
                            <Link to='/'>
                                <button className='g-button med-btn'>
                                    Cancel
                                </button>
                            </Link>
                            <button className='g-button med-btn primary' onClick={(e) => handleSubmit(e)}>
                                Sign In
                            </button>
                            {/* <CustomButton onClick={signInWithGoogle} isGoogleSignIn>
                                Sign In With Google
                            </CustomButton>*/} 
                        </div>
                        <div className="g-space-20"></div>
                        <div className='center-box'>
                            <h4>Don&apos;t have an account?<br />Register <Link to='/register'><b>HERE</b></Link>!</h4>
                        </div>
                    </div>
                </div>
            </div>
            </UnauthLayout>
            <ModalAlert show={alertMessage} cancel={() => setAlertMessage(null)} message={alertMessage} />
        </div>
    )
}

export default SignIn
